// src/composables/useTransliteration.js
export function useTransliteration() {
  const latinToCyrillicMap = {
    'A': 'А', 'B': 'Б', 'V': 'В', 'G': 'Г', 'D': 'Д', 'Đ': 'Ђ', 'E': 'Е', 'Ž': 'Ж',
    'Z': 'З', 'I': 'И', 'J': 'Ј', 'K': 'К', 'L': 'Л', 'M': 'М', 'N': 'Н', 'O': 'О',
    'P': 'П', 'R': 'Р', 'S': 'С', 'T': 'Т', 'Ć': 'Ћ', 'U': 'У', 'F': 'Ф', 'H': 'Х',
    'C': 'Ц', 'Č': 'Ч', 'Š': 'Ш',

    'a': 'а', 'b': 'б', 'v': 'в', 'g': 'г', 'd': 'д', 'đ': 'ђ', 'e': 'е', 'ž': 'ж',
    'z': 'з', 'i': 'и', 'j': 'ј', 'k': 'к', 'l': 'л', 'm': 'м', 'n': 'н', 'o': 'о',
    'p': 'п', 'r': 'р', 's': 'с', 't': 'т', 'ć': 'ћ', 'u': 'у', 'f': 'ф', 'h': 'х',
    'c': 'ц', 'č': 'ч', 'š': 'ш'
  }

  const cyrillicToLatinMap = Object.fromEntries(
    Object.entries(latinToCyrillicMap).map(([lat, cyr]) => [cyr, lat])
  )

  const toCyrillic = (text) =>
    text?.split('').map(ch => latinToCyrillicMap[ch] || ch).join('') || ''

  const toLatin = (text) =>
    text?.split('').map(ch => cyrillicToLatinMap[ch] || ch).join('') || ''

  return { toCyrillic, toLatin }
}
